import { ButtonIcon, Icon } from "@saviynt/design-system";
import { Link } from "@tanstack/react-router";
import { SaviyntLogo } from "../SaviyntLogo";
import { UserProfile } from "../UserProfile";

export interface HeaderUser {
  displayName?: string;
}

interface HeaderProps {
  theme: "light" | "dark";
  onToggleTheme: () => void;
  onLogout: () => void;
  /** Optional user info for profile display (e.g. "First Last") */
  user?: HeaderUser;
  /**
   * When false, hides the Saviynt logo on the header — typically used when the
   * Sidenav is expanded/pinned and already renders the logo on itself.
   * Defaults to true.
   */
  showLogo?: boolean;
  /**
   * When false, hides Help and Notifications icons from the header.
   * Defaults to true.
   */
  showHeaderActions?: boolean;
}

export function Header({
  theme,
  onToggleTheme,
  onLogout,
  user,
  showLogo = true,
  showHeaderActions = true,
}: HeaderProps) {
  return (
    <header className="h-16 border-b border-[var(--color-border-neutral-subtlest)] bg-[var(--color-background-neutral-subtlest)] flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        {showLogo && (
          <Link to="/" className="flex items-center">
            <SaviyntLogo variant={theme} className="h-7" />
          </Link>
        )}
      </div>
      <div className="flex items-center gap-2">
        {showHeaderActions && (
          <>
            <ButtonIcon
              kind="outlinedNeutral"
              icon={<Icon kind="HelpOutlined" size="small" />}
              size="medium"
              ariaLabel="Help"
            />
            <ButtonIcon
              kind="outlinedNeutral"
              icon={<Icon kind="Notification" size="small" />}
              size="medium"
              ariaLabel="Notifications"
            />
          </>
        )}
        <UserProfile
          onLogout={onLogout}
          userName={user?.displayName}
          theme={theme}
          onToggleTheme={onToggleTheme}
        />
      </div>
    </header>
  );
}
